export const getAnchor = (slug) => {
  const pathArray = slug.split('/')
  return pathArray[pathArray.length - 2]
}
